import { render, staticRenderFns } from "./UploadImageModal.vue?vue&type=template&id=8eb0810a&scoped=true&"
import script from "./UploadImageModal.vue?vue&type=script&lang=js&"
export * from "./UploadImageModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageModal.vue?vue&type=style&index=0&id=8eb0810a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb0810a",
  null
  
)

export default component.exports